import { SET_TAGS, ADD_TAG, EDIT_TAG, REMOVE_TAG } from "./mutation-types";
import { RESET } from "../../mutation-types";

const mutations = {
  [SET_TAGS](state, tags) {
    const mappedTags = tags.map((tag) => {
      tag.filterType = "TAG";
      tag.searchCriteria = {};
      tag.tabIndex = -1;
      return tag;
    });
    state.tags = mappedTags;
  },
  [ADD_TAG](state, tag) {
    state.tags.push(tag);
  },
  [EDIT_TAG](state, editedTag) {
    const index = state.tags.findIndex((tag) => tag.id === editedTag.id);
    if (index !== -1) {
      state.tags.splice(index, 1, editedTag);
    }
  },
  [REMOVE_TAG](state, tagId) {
    state.tags = state.tags.filter((tag) => tag.id !== tagId);
  },
  [RESET](state) {
    state.tags = [];
  },
};

export default mutations;
